export const API_URL = 'https://admin-api.muavietlot.com';
export default API_URL;
